import ConversationItem from 'models/conversation_item';
import PaymentStatusEventContent from 'models/payment_status_event_content';

export default function createPaymentStatusEventItem({ customerId, eventType, initiator, secureDataItemId }) {
  return ConversationItem.create({
    content: PaymentStatusEventContent.create({
      eventType,
      secureDataItemId,
    }),
    customerId,
    initiator,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/conversation_item/create_payment_status_event_item.js